export const USER_ROLES = {
    // Admin and InitialEvaluator , AdminEntityroles
    ADMIN: "Admin",
    INITIAL_EVALUATOR: "InitialEvaluator",
    ADMIN_ENTITY: "AdminEntity",
    ENTITY_REVIEWER: "EntityReviewer",
}